import type { TourDefinition } from '../types'

export const dagsterTour: TourDefinition = {
  id: 'dagster',
  title: 'Dagster Tour',
  description: 'Explore assets, runs, and lineage in your Dagster instances.',
  icon: 'Layers',
  route: '/tenant/data/dagster',
  estimatedMinutes: 3,
  steps: [
    {
      element: '[data-tour-id="dagster-instance-selector"]',
      popover: {
        title: 'Select Instance',
        description: 'Switch between Dagster instances across your connected clusters.',
      },
      aiContext: 'How do I add more Dagster instances to this dropdown?',
    },
    {
      element: '[data-tour-id="dagster-assets-tab"]',
      popover: {
        title: 'Data Assets',
        description: 'Browse all Dagster assets. Click any row to see its history, checks, and lineage.',
      },
      aiContext: 'What is a Dagster asset and how is it different from a job?',
    },
    {
      element: '[data-tour-id="dagster-runs-tab"]',
      popover: {
        title: 'Job Runs',
        description: 'View all Dagster runs. Success/Failure status with timestamps.',
      },
      aiContext: 'How do I filter Dagster runs by job name or date range?',
    },
    {
      element: '[data-tour-id="dagster-run-row"]',
      popover: {
        title: 'Expand a Run',
        description: 'Click any row to expand the full event log — Kubernetes executor events, step timings, and errors.',
      },
      aiContext: 'What information is in the Dagster run event log and how do I debug a step failure?',
    },
    {
      element: '[data-tour-id="dagster-lineage-tab"]',
      popover: {
        title: 'Data Lineage',
        description: 'Visualize upstream and downstream dependencies for each asset.',
      },
      aiContext: 'How does Vharta capture and display Dagster data lineage?',
    },
  ],
}
